import { Routes } from '@angular/router';
import { IntroductionComponent } from '@prekog/common-ui';
import { BlogListComponent } from './bloglist/bloglist.component';
import { BlogPieceComponent } from './blogpiece/blogpiece.component';
import { ConsultationComponent } from './consultation/consultation.component';
import { ConsultinghoursComponent } from './consultinghours/consultinghours.component';
import { DoctorComponent } from './doctor/doctor.component';
import { GyikComponent } from './gyik/gyik.component';
import { HealthfundComponent } from './healthfund/healthfund.component';
import { HomeComponent } from './home/home.component';
import { PricelistComponent } from './pricelist/pricelist.component';
import { SmartiesComponent } from './smarties/smarties.component';
import { SmartyComponent } from './smarty/smarty.component';
import { SpecialitydescriptionComponent } from './specialitydescription/specialitydescription.component';

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'introduction', component: IntroductionComponent },
    { path: 'consultation', component: ConsultationComponent },
    { path: 'healthfund', component: HealthfundComponent },
    { path: 'doctor/:routerLink', component: DoctorComponent, pathMatch: 'full' },
    { path: 'pricelist', component: PricelistComponent },
    { path: 'consultation/:routerLink', component: SpecialitydescriptionComponent },
    { path: 'consultatinghours', component: ConsultinghoursComponent },
    { path: 'blog', component: BlogListComponent },
    { path: 'blog/:id', component: BlogPieceComponent },
    { path: 'gyik', component: GyikComponent },
    { path: 'smarties/:id', component: SmartyComponent },
    { path: 'smarties', component: SmartiesComponent }
];
